<template>
  <div class="pages-box" style="height:100vh;">
    <div class="westernmedicin-content-box" style="height: 100%">
      <!-- 左侧模块 -->
      <!-- <div class="grid-leftcontent-box"></div> -->
      <!-- 右侧智能问诊模块 -->
      <div class="grid-rightcontent-box">
        <div class="grid-rightcontent-title">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="辅助诊疗" name="auxiliary"></el-tab-pane>
            <el-tab-pane label="医学知识" name="knowledge"></el-tab-pane>
            <el-tab-pane label="医嘱审核" name="review"></el-tab-pane>
            <el-tab-pane label="DeepSeek" name="DeepSeek"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="grid-rightcontent-info-box">
          <!-- 辅助诊疗模块 -->
          <div class="rightcontent-info-bodybox" v-if="activeName == 'auxiliary'">
            <div class="src-components-PushItems-RKWqd">
              <div class="src-components-PushItems-1jpJi src-Items-cbzd">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  AI诊断
                </h1>
                <!-- 疑似诊断列表 -->
                <div v-if="dpzd.length > 0">
                  <div class="ysblList-items-box" :class="index == clickIndex ? 'hoverClass' : ''" v-for="(item, index) in dpzd.diagnosis"
                       :key="index" @click.stop="clickYsbl(item.name, index)">
                    <div style="font-weight: 600;padding-bottom: 5px;display: flex;align-items: center; justify-content: space-between;">
                      <div>
                        <span>
                          {{ item.name }}
                          <span v-if="item.confidence">【置信度:{{item.confidence}}】</span>
                        </span>
                      </div>
                    </div>
                    <div class="ysblList-items-text">
                      判断原因:{{ item.reason}}
                    </div>
                  </div>
                </div>
                <div style="padding: 6px 0 6px 15px" v-else>深度思考中....</div>
                <!-- 疑似诊断列表结束 -->
              </div>
              <!-- 疑似诊断模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  疑似诊断
                </h1>
                <!-- 疑似诊断列表 -->
                <div v-if="disease_list.length > 0">
                  <div class="ysblList-items-box" :class="index == clickIndex ? 'hoverClass' : ''" v-for="(item, index) in disease_list"
                       :key="index" @click.stop="clickYsbl(item.name, index)">
                    <div style="font-weight: 600;padding-bottom: 5px;display: flex;align-items: center; justify-content: space-between;">
                      <div>
                        <span class="icon-outline" style="padding:2px 4px;" title="点击使用此项,主要诊断项显示" @click.stop="clickYszdIcon(item.name)">+</span>
                        <span>
                          {{ item.name }}
                          <span v-if="item.confidence_level">【置信度:{{item.confidence_level}}】</span>
                        </span>
                      </div>
                      <!-- <a class="cjyp-table-tr-r" href="javascript:0;" @click="click_ypxq('Disease', item.name)">查看详情</a> -->
                    </div>
                    <div class="ysblList-items-text">
                      {{ item.pathogenesis ? item.pathogenesis : "暂无" }}
                    </div>
                  </div>
                </div>
                <div style="padding: 6px 0 6px 15px" v-else>暂无数据...</div>
                <!-- 疑似诊断列表结束 -->
              </div>
              <!-- 疑似诊断模块结束 -->

              <!-- 相关症状模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list" style="max-height:132px;">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  相关症状
                </h1>
                <!-- 相关症状列表 -->
                <div style="min-height:60px;">
                  <div class="cjyp-table-div">
                    <span class="cjyp-table-span" v-for="(item, index) in symptom_list" :key="index">{{ item.name }}</span>
                  </div>

                  <!-- <div class="cjyp-table-tr" v-for="(item, index) in symptom_list" :key="index">
                    <div class="cjyp-table-tr-l" @click="clickInspectionIcon(item.name)">
                      <span class="icon-outline" style="padding:2px 4px;" title="点击使用此项">+</span>
                      <span>{{ item.name }}</span>
                    </div>
                    <a class="cjyp-table-tr-r" href="javascript:0;" @click="click_ypxq('Zztz', item.name)">查看详情</a>
                  </div> -->
                  <div style="padding: 6px 0 6px 15px" v-if="!symptom_list || symptom_list.length <= 0">暂无数据...</div>
                </div>
                <!-- 相关症状列表结束 -->
              </div>
              <!-- 相关症状模块结束 -->

              <!-- 查体模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list" style="max-height:132px;">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  查体
                </h1>
                <!-- 查体列表 -->
                <div style="min-height:60px;">
                  <div class="cjyp-table-div">
                    <span class="cjyp-table-span" v-for="(item, index) in examination_list" :key="index">{{ item.name }}</span>
                  </div>
                  <div style="padding: 6px 0 6px 15px" v-if="!examination_list || examination_list.length <= 0">暂无数据...</div>
                </div>
                <!-- 查体列表结束 -->
              </div>
              <!-- 查体模块结束 -->


              <!-- 常见检查模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  常见检查
                </h1>
                <!-- 常见检查列表 -->
                <div>
                  <div class="cjyp-table-tr" v-for="(item, index) in inspection_list" :key="index">
                    <div class="cjyp-table-tr-l">
                      <span class="icon-outline" style="padding:2px 4px;">+</span>
                      <span>{{ item.name }}</span>
                    </div>
                  </div>
                  <div style="padding: 6px 0 6px 15px" v-if="!inspection_list || inspection_list.length <= 0">暂无数据...</div>
                </div>
                <!-- 常见检查列表结束 -->
              </div>
              <!-- 常见检查模块结束 -->

              <!-- 常见药品模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list">
                <h1 style="background: #EAF7FA;">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAfRJREFUOBGtVDEzxFAQ3ncSBa2CRqdUUPgBFAztxQw5nEZDqzyFK9UajRyOIkpuruEHKCiUOgoKLYWEZ3fz9k2Si4wZMnPv7e1++82+9+0+gL982lupc75ero+VEllkIUqiulp7SvgW/SYZuupr3j3/sAIa1jgqizO4zaakSRVKALSzM45WQbv7ANGNCtuj6TgDpABO8GqXAhBmZtRefViFwYsmgNbzAlLnbROvPYsPKzdHsR4sBa+rsEbCaDwigJoDZ2BcnR28pvJ+Z2ZP7fmPAO4UqGgTHPdInQYPPTT5GtP1WXAaxCc3kQwYQYHNQEN0E582elZAwax1iri4I/MF+1klYljaGMqoYsA2mQ9o/tGlpsEWVCBCr945UPYesQyI3++xoC52zrow054BpgNkU/0Qv+2xpBzUXcCGLZO2kJAb5iO+BqUaKjwOmMssfGatm9DvTBcpnCEsI0qTkv0TMROao90CVHbyFXGykUrmIk2eqPS1i1cxSVeREHo0OM4EDZeA80Mmft6V6qjwZEF8NJgA8R36RpzEiZdNnQ/QEFAmoaTCBP+5RYqTXaGFpccxomEoajQUp4M/+25QDn2E5QFy+1rSPhlRGESP5w8KM4shwjenUOkeQptExFF0hZ3aSp4/jNC10EPqujNFLSO5/7p/A6iJBGKnQxzOAAAAAElFTkSuQmCC" alt=""/>
                  常见药品
                </h1>
                <!-- 常见药品列表 -->
                <div>
                  <div class="cjyp-table-tr" v-for="(item, index) in medicine_list" :key="index">
                    <div class="cjyp-table-tr-l" @click="clickMedicineIcon(item.name)">
                      <span class="icon-outline" style="padding:2px 4px;" title="点击使用此项">+</span>
                      <span>{{ item.name }}</span>
                    </div>
                  </div>
                  <div style="padding: 6px 0 6px 15px" v-if="!medicine_list || medicine_list.length <= 0">暂无数据...</div>
                </div>
                <!-- 常见药品列表结束 -->
              </div>
              <!-- 常见药品模块结束 -->

              <!-- 相关手术模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  相关手术
                </h1>
                <!-- 相关手术列表 -->
                <div>
                  <div class="cjyp-table-tr" v-for="(item, index) in relevantOperation_list" :key="index">
                    <div class="cjyp-table-tr-l">
                      <span class="icon-outline" style="padding:2px 4px;">+</span>
                      <span>{{ item.name }}</span>
                    </div>
                  </div>
                  <div style="padding: 6px 0 6px 15px" v-if="!relevantOperation_list || relevantOperation_list.length <= 0">暂无数据...</div>
                </div>
                <!-- 相关手术列表结束 -->
              </div>
              <!-- 相关手术模块结束 -->

              <!-- 治疗方案模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  治疗方案
                </h1>
                <!-- 治疗方案列表 -->
                <div>
                  <div class="cjyp-table-tr">
                    <div class="cjyp-table-html" v-html="treatment_list"></div>
                  </div>
                  <div style="padding: 6px 0 6px 15px" v-if="!treatment_list || treatment_list.length <= 0">暂无数据...</div>
                </div>
                <!-- 治疗方案列表结束 -->
              </div>
              <!-- 治疗方案模块结束 -->

              <!-- 鉴别诊断模块开始 -->
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  鉴别诊断
                </h1>
                <!-- 鉴别诊断列表 -->
                <div>
                  <div class="cjyp-table-tr">
                    <div class="cjyp-table-html" v-html="identity_list"></div>
                  </div>
                  <div style="padding: 6px 0 6px 15px" v-if="!identity_list || identity_list.length <= 0">暂无数据...</div>
                </div>
                <!-- 鉴别诊断列表结束 -->
              </div>
              <!-- 鉴别诊断模块结束 -->

            </div>
          </div>
          <!-- 辅助诊疗模块结束 -->

          <!-- 医学知识模块 -->
          <div class="rightcontent-info-bodybox" v-if="activeName == 'knowledge'">
            <div class="col-left-title"><p>{{ getZskNewDetailInfo.name }}</p></div>
            <div class="src-components-PushItems-RKWqd">
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list" style="max-height: 100%" v-if="getZskNewDetailInfo.content && getZskNewDetailInfo.content.data && Array.isArray(getZskNewDetailInfo.content.data) && !!(getZskNewDetailInfo.content.data.length)">
                <div v-for="(item, index) in getZskNewDetailInfo.content.data" :key="index">
                  <div v-for="(value, key) in item" :key="key">
                    <h1>
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                      {{ value.name }}
                    </h1>
                    <div>
                      <div class="cjyp-table-tr">
                        <div style="max-height:300px;overflow: auto;padding: 6px 0px 6px 15px;" class="cjyp-table-html" v-html='value.text ? value.text : "暂无数据..."' ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-empty description="暂无数据..." v-else></el-empty>
            </div>
          </div>
          <!-- 医学知识模块结束 -->

          <!-- 医嘱审核模块 -->
          <div class="rightcontent-info-bodybox review" v-if="activeName == 'review'">

            <div class="src-components-PushItems-RKWqd">
              <div class="src-components-PushItems-1jpJi src-Items-cbzd src-Items-list" v-for="(item, index) in getYZMCList" :key="index">
                <h1>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAa9JREFUOBGtVKFSxDAQfem0CLAIFA6JQdwHgIAPuDIDPeAwGLDIQ3ASjcFwwByI4wPOwAcgMEgcCAwWBC2E7KbpNLm0HAMRSTb79mXzdlvgL0PGG22Ol+vtuVqiAulFGa9stp4132rSLSNlnJwGkNgqHyKc2tfoPMxkIcooPszSTcjoGEjvxKA/W/aDACYBy6GMIiFyyLg9w2szkd41br3QOQ8r0pwpubw5kp+eCIgVhJPz4urkNY8Zf7FfHSdPQNSASHcRRufisvc4QuXmSCqY/AqwCzIOC6xAPePwrTKvZwCBZQLICg11lQiwtjNdVRUm4AfSTo2qEnpzd8EuyNZRpYHs/UHdMVSds63v07MFLDtoT/kjezvikrJTDqlh60rrJeSCfGS3EKIjBhc95sonFkjKLibCRV+FLcI6ojIp7auImTB/2j0QHLgZuUSurUv6daikWCApAgawwFHDkFFzmAYhf52tY1SjMwcQ6huV2NT5QIdscd23pPjJBj73qOIcSxON3+inI/w6WpmMS1xVEIofISxup79ymt4oxFnxYZEs9CONoiVfy5jYf12/AekE+Xpx4MgpAAAAAElFTkSuQmCC" alt=""/>
                  {{ item.name }}
                </h1>
                <div style="min-height:60px;">
                  <div class="cjyp-table-tr">
                    <div class="cjyp-table-html" v-if="item.rule_result">{{ item.rule_result }}</div>
                    <div class="cjyp-table-html" v-if="item.rule_tip">{{ item.rule_tip }}</div>
                    <div class="cjyp-table-html" v-if="item.rule_result == '' && item.rule_tip == '' ">暂无数据...</div>
                  </div>
                </div>
              </div>
              <el-empty description="暂无数据..." v-if="getYZMCList.length <= 0"></el-empty>
            </div>

          </div>
          <!-- 医嘱审核模块结束 -->
          <!-- DeepSeek模块 -->
          <div class="messageBox" v-if="activeName == 'DeepSeek'" style="width: calc(100%)">
            <div class="message"  ref="messageScrollable">
              <div v-for="(item,index) in chatMessages" :key="index">
                <div v-if="item.role == 'user'" class="user-message">
                  <div class="user-content">
                    {{item.content}}
                  </div>
                  <img src="../assets/image/DeepSeek/img.png" style="width: 40px;height: 40px;">
                </div>
                <div v-if="item.role == 'assistant'" class="record-message">
                  <img src="../assets/image/DeepSeek/jiqiren.png" style="width: 40px;height: 40px;">
                  <div class="record-content">
                    {{item.content}}
                  </div>
                </div>
              </div>
            </div>
            <div class="sendMessageBox">
              <textarea class="inputText" v-model="inputMessage" placeholder="请输入您的问题,帮您深度解答"></textarea>
              <el-row type="flex" justify="space-between" align="middle" >
                <div></div>
                <el-button type="primary" @click="sendMessage()" icon="el-icon-top" circle></el-button>
              </el-row>
            </div>

          </div>
          <!-- DeepSeek模块结束 -->
        </div>

        <div class="mz-box">
          <span style="color: #27afa1">免责声明: </span>以上仅供参考,以医生临床诊断为主
        </div>
      </div>
      <!-- 右侧智能问诊模块结束 -->
    </div>

  </div>
</template>

<script>
import {
  getPatientAuxiliaryInfo,
  getAboutResultList,
  clickYsbl,
  getNewBaseDetail,
  getZskNewDetail,
  getyzEamine,
  getDeepSeekInfo
} from '@/api/data'
// import sourceData from './data'
import axios from '@/api/axios';
export default {
  name: "CDSSPages",
  components: {
  },
  data(){
    return {
      dpzd:{},
      chatMessages:[],//DeepSeek聊天记录
      inputMessage:"",//DeepSeek对话输入框内容
      viewHeight: 0,
      str: '', // 症状
      age: '', // 年龄
      sex: '', // 性别
      infoData: [], // 主页数据
      checkList: [],
      diseaseInfo: {},
      disease_list: [], // 获取的辅助诊疗疑似病例数据
      getinfo: {}, //点击病例弹窗查看详情
      clickIndex: -1, //疑似病例列表下标
      hot_name: "", //疑似病例列表标题
      medicine_list: [], //  常见药品
      inspection_list: [], // 常见检查
      complication_list: [], // 并发症
      identity_list: "", // 鉴别诊断
      symptom_list: [], // 相关症状
      examination_list: [], // 查体
      treatment_list: '', // 治疗方案
      relevantOperation_list: [], // 相关手术
      activeName: "auxiliary",
      // 知识库疾病详情、检查异常
      zhonglian_name: '',
      tag: '',
      getZskNewDetailInfo:{},
      getZskNewDetailList: [],
      getYZMCInfo:{},
      getYZMCList: [],
      YZMC: '',
      XB: '男',
      NL: 0,
    }
  },
  mounted() {

    this.$watch(() => this.$route.query, (newQuery) => {
      this.ZYH = newQuery.ZYH;
      this.getData();
    },{ deep: true });
  },
  created() {
    let getViewportSize = this.$getViewportSize();
    this.viewHeight = getViewportSize.height;
    document.title = this.name || '辅助医疗';

    if(this.$route.query.ZYH){
      this.ZYH = this.$route.query.ZYH;
    }
    if(this.$route.query.TCJD){
      let TCJD = this.$route.query.TCJD;
      // 疑似诊断
      if(TCJD == 1){
        this.activeName = 'auxiliary';
      }
      // 知识库详情
      if(TCJD == 2){
        this.activeName = 'knowledge';
      }
      // 医嘱审核
      if(TCJD == 3){
        this.activeName = 'review';
      }
    }
    this.getData();
  },
  methods:{
    //region DeepSeek
    //对话内容滑动
    messageScrollable(){
      this.$nextTick(()=>{
        const messageScrollable = this.$refs.messageScrollable;//获取对话框滚动条
        if (messageScrollable){
          messageScrollable.scrollTop = messageScrollable.scrollHeight;
        }
      })
    },
    //发送对话框内容
    async sendMessage(params){
      const messages = params ? params : this.inputMessage.trim();
      if (messages){
        //添加用户信息到聊天记录
        this.chatMessages.push({
          role: 'user',
          content: messages
        });
        //滚动条滚动到最底部
        this.messageScrollable();
        // 清空输入框
        this.inputMessage = '';
        //大模型请求
        console.log('开始请求大模型');
        const modelResponse = await this.simulateModelResponse(messages);

        console.log(modelResponse);
        // 添加模型响应消息到聊天记录
        this.chatMessages.push({
          role: 'assistant',
          content: modelResponse
        });
        //滚动条滚动到最底部
        this.messageScrollable();
      }
    },

    //大模型请求
    simulateModelResponse(userMessage){
      //body内容
      const body = {};
      body.model = "deepseek-r1:14b";
      body.messages = [{"role":"user","content":userMessage}];
      body.stream = false;
      const options = JSON.stringify(body);
      return  getDeepSeekInfo(options).then((res) =>{
        return  res.data.message.content;
      }).catch((e) => {console.log(e)});
    },

    //AI诊断
    aiDiagnosis(value){
      //body内容
      const body = {};
      body.model = "deepseek-ai/DeepSeek-R1";
      body.messages = [{"role":"user","content":value}];
      //body.stream = false;
      const options = JSON.stringify(body);
      return  getDeepSeekInfo(options).then((res) =>{
        let content = res.data.choices[0].message.content;
        //let matches = content.match(/\[([^\]]+)\]/g);
        this.dpzd = JSON.parse(content);
        console.log(this.dpzd);
      }).catch((e) => {console.log(e)});
    },
    //endregion

    getData(){
      this.getPatientAuxiliaryInfo();
    },
    // 点击右侧模块头部分页
    handleClick(tab) {
      this.activeName = tab.name;
    },
    getPatientAuxiliaryInfo(){
      let that = this;
      let p = {
        zyh: that.ZYH,
      }
      that.diseaseInfo = {};
      that.disease_list = [];
      getPatientAuxiliaryInfo(p).then( res =>{
        let data = res.data.data;
        if(Array.isArray(data) && data.length === 0) {
          if(this.activeName == 'auxiliary') {
            that.diseaseInfo = {};
            that.disease_list = [];
          }
          if(this.activeName == 'knowledge') {
            that.getZskNewDetailInfo = {};
            that.getZskNewDetailList = []
          }
          if(this.activeName == 'review') {
            that.getYZMCInfo = {};
            that.getYZMCList = [];
          }
          return
        }
        data.forEach( ele =>{
          if(ele.tag == "auxiliary"){
            that.diseaseInfo = ele;
            that.disease_list = ele.content;
          }
          if(ele.tag == "knowledge"){  // 医学知识
            that.getZskNewDetailInfo = ele;
            that.getNewBaseDetail(ele.content.data);
          }
          if(ele.tag == "review"){ // 医嘱
            that.getYZMCInfo = ele;
            that.getYZMCList = ele.content;
          }
        })
        //如果主诉存在，则发起请求
        const zszz = data[0].zszz;
        if (zszz){
          const message = "主诉:\""+zszz+"\"。根据主诉生成疑似诊断名称,判断原因,以及置信度,置信度区间范围为1-100的正整数，按照置信度的数字大小从高往低排,数量不超过五个。返回的数据采用json格式。疑似诊断名称使用name，判断原因使用reason,置信度使用confidence。";
          this.aiDiagnosis(message)
        }
      }).catch( e =>{
        console.log(e)
      })
    },
    // 获取疑似诊断
    getManySelect(){
      let that = this;
      let str = that.str;
      // advisory_content.push({
      //   title: "主诉",
      //   text: symptoms,
      // });
      let p = {
        age: Number(that.age),
        str,
      }
      if(that.sex){
        p.sex = that.sex;
      }
      getAboutResultList(p).then((res) => {
        if (res.data.code == 0) {
          that.disease_list = res.data.data; //疾病列表
        } else if (res.data.code == 1) {
          that.$message.error({
            message: res.data.msg,
          });
        }
      })
        .catch((e) => {
          loading.close();
          console.log(e);
        });
    },
    // 点击疑似病例
    clickYsbl(n, i) {
      let that = this;
      that.click_ysbl(n, i);
    },
    click_ysbl(n, i, f) {
      let that = this;
      let name = n;
      let index = i;
      that.hot_name = name;
      that.clickIndex = index;
      let pearms = {
        disease_name: name,
      };
      clickYsbl(pearms).then((res) => {
        if (res.data.code == 0) {
          that.medicine_list = res.data.data.medicine_list; //药品列表
          that.inspection_list = res.data.data.inspection_list; //检查列表
          that.complication_list = res.data.data.complication_list; //并发症
          that.identity_list = res.data.data.identity_list; //鉴别诊断
          that.symptom_list = res.data.data.symptom_list;// 相关症状
          that.examination_list = res.data.data.examination_list; // 查体
          that.treatment_list = res.data.data.treatment_list; // 治疗方案
          that.relevantOperation_list = res.data.data.relevantOperation_list; // 相关手术
          if( typeof(f) == "function"){
            let graph = res.data.data.graph; //图谱
            that.is_casePop = true;
            return f(graph);
          }
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    // 点击诊断查看详情
    click_ypxq(t, n,k) {
      let that = this;
      let tag = t;
      let name = n;
      let kgid = k;
      let symptoms = that.symptoms;
      let pearms = {
        name,
        tag: tag,
        symptoms,
      };

      if( kgid && (tag == 'CnMedicinalCrop' || tag == 'zySickNess' || tag == 'ChannelCollateral') ){
        pearms.sickness = kgid
      }
      getNewBaseDetail(pearms).then((res) => {
        if (res.data.code == 0) {
          let getinfo = {};
          if( tag == "Inspection"){
            getinfo = res.data.data[0];
          }else{
            getinfo= res.data.data;
          }
          // that.name_1 = getinfo.name.text;
          let getinfo_arr = [];
          for (let key in getinfo) {
            let is_list = 0;
            if (getinfo[key].text.name) {
              is_list = 1;
            }
            if (
              getinfo[key].name != "名称" &&
              getinfo[key].text != "" &&
              getinfo[key].text != "[]" &&
              getinfo[key].name != "kgid"
            ) {
              getinfo_arr.push({
                is_list,
                name: getinfo[key].name,
                text: getinfo[key].text.name
                  ? getinfo[key].text.name
                  : getinfo[key].text,
                tag: getinfo[key].text.name ? getinfo[key].text.tag : "",
              });
            }
          }
          that.getinfo = getinfo_arr;
          // this.is_ypxq = true;
        }
      })
        .catch((e) => {
          console.log(e);
        });
    },
    //获取西医知识库详情页数据
    getNewBaseDetail(data){
      let getinfo_arr = [];
      let that = this;
      console.log('>>>>>>>data', data)
      Array.isArray(data) && data.forEach((element) => {
        let getinfo = element;
        // if(that.tag == 'Inspection'){
        //   getinfo = res.data.data[0];
        // }else{
        //   getinfo = res.data.data;
        // }
        that.name = getinfo.name.text;
        for (let key in getinfo) {
          let is_list = 0;
          if (getinfo[key].text.name) {
            is_list = 1;
          }
          if (
            getinfo[key].name != "疾病名称" &&
            getinfo[key].text != "" &&
            getinfo[key].text != "[]" &&
            getinfo[key].name != "kgid"
          ) {
            getinfo_arr.push({
              textName: getinfo.name.text,
              is_list,
              name: getinfo[key].name,
              text: getinfo[key].text.name
                ? getinfo[key].text.name
                : getinfo[key].text,
              tag: getinfo[key].text.name ? getinfo[key].text.tag : "",
            });
          }
        }
      })

      that.getZskNewDetailList = getinfo_arr;
    },
    getyzEamine(){
      let that = this;
      let params = {
        XB: that.XB,
        NL: that.NL,
        YZMC: that.YZMC,
      };
      getyzEamine(params).then(res =>{
        if(res.data.code == 0){

        }
      }).catch( e =>{
        console.log(e)
      })
    },


  }

}
</script>

<style scoped>
.messageBox {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.message {
  flex: 1;
  margin-bottom: 20px;
  max-height: 75vh;
  overflow-y: scroll;
  background-color: white;
  border-radius: 10px;
  font-size: 14px;
  text-align: left;
}
.user-message{
  display: flex;
  margin: 10px 10px 20px 10px;
  justify-content: right;
}
.user-content {
  line-height: 40px;
  background-color: #bee2f8;
  margin-right: 10px;
  border-radius: 5px;
  padding: 0 10px 0 10px;
  flex: 1;
}
.record-message {
  display: flex;
  margin: 10px 10px 20px 10px;
}
.record-content {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  width: 360px;
  margin-left:10px;
  padding: 0 10px 0 10px;
  border-radius: 5px;
  line-height: 40px;
  flex: 1
}
.sendMessageBox {
  width: 392px;
  position: fixed;
  bottom: 40px;
  padding: 10px;
  border: 1px solid #bbb;
  border-radius: 8px;
  height: 100px;
}

.inputText {
  width: 100%;
  height: 40px;
  border: none;
  outline:none;
  resize: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
}
.el-main{
  padding-top: 20px;
}
@import "../assets/css/WesternMedicineCdss.css";
.col-left-title {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #f2f2f2;
}
.item-text-a{
  padding:4px 6px;
}
.col-left-title p{
  font-size: 14px;
  font-weight: 600;
  line-height: 35px;
  color: #191919;
}
.cjyp-table-div{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.cjyp-table-span{
  padding: 6px 5px;
  font-size: 14px;
}
.src-components-PushItems-RKWqd {
  padding-bottom: 20px;
}
.pages-box{
  /* width: 1200px; */
  padding: 8px 4px;
  background: #fff;
  height: 100%;
}
.grid-rightcontent-box{
  max-width: 420px;
}
.westernmedicin-content-box{
  justify-content: center;
}
.el-empty {
  padding: 10px 0;
}
li {
  list-style: none;
}
.review .cjyp-table-tr{
  padding: 5px;
  align-items: flex-start;
  flex-direction: column;
}
.review .cjyp-table-tr>div{
  padding-top: 10px;
}
/* 多选框边框跟样式 */
.el-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #27afa1;
  border-color: #27afa1;
}
.el-checkbox >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #27afa1;
}
.el-checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #27afa1;
}
.el-checkbox >>> .el-checkbox.is-bordered.is-checked {
  border-color: #27afa1;
}
.leftcontent-title-box >>> .el-input__inner:focus {
  border-bottom: 1px solid #27afa1;
}
.el-input-box >>> input:focus {
  border-color: #27afa1;
}
.el-select >>> .el-input__inner:focus {
  border-color: #27afa1;
}
.el-oplistselect-box.el-select >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  background: none;
  padding-left: 4px;
  padding-right: 20px;
}
.src-components-PatInfo-2ZUg6 >>> .el-input__inner{
  width:100%;
  height: 30px;
  line-height: 30px;
  border: none;
  border-radius: 0;
  border-right: 1px solid #dcdfe6;
  padding: 0 5px;
}
.src-components-PatInfo-2ZUg6 >>> .el-input--prefix .el-input__inner{
  padding-left: 26px;
}
.src-components-PatInfo-2ZUg6 >>> .el-input.is-focus .el-input__inner{
  border-color: #27afa1;
}
.el-oplistselect-box.el-select >>> .el-input__icon {
  line-height: 30px;
  width: auto;
}

.el-oplistselect-box.el-select >>> .el-input.is-focus .el-input__inner {
  border-color: #27afa1;
}
.el-select-dropdown__item.selected {
  color: #27afa1;
}
.el-input-box >>> .el-input__inner {
  height: 34px;
  line-height: 34px;
}
.el-input-box >>> .el-input__suffix {
  top: -5px;
  padding-top: 0;
}
.el-input-box >>> .el-input-group__append {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 100%;
  padding-bottom: 1px;
}
.el-input-box >>> .el-button {
  width: 72px;
  background: #27afa1;
  color: #fff;
  font-size: 14px;
  padding: 0;
  height: 34px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.el-checkbox{
  padding:0 4px;
}
.el-checkbox >>> .el-checkbox__label {
  font-size: 14px;
  padding-left: 2px;
  margin: 4px 0;
}

.src-265y8 .el-oplistselect-box.el-select >>> .el-input__inner {
  border: none;
  text-align: center;
  padding-right: 4px;
}
.src-265y8 .el-oplistselect-box.el-select >>> .el-input__suffix {
  display: none;
}
.grid-rightcontent-title >>> .el-tabs__item.is-active {
  color: #27afa1;
}
.grid-rightcontent-title >>> .el-tabs__active-bar {
  background-color: #27afa1;
}
.grid-rightcontent-title >>> .el-tabs__item:hover {
  color: #27afa1;
}
.grid-rightcontent-title >>> .el-tabs__item {
  padding: 0 10px;
  font-size: 16px;
  font-weight: 600;
}
.grid-rightcontent-title >>> .el-tabs__header {
  margin: 0;
}
.demo-input-suffix >>> .el-input{
  width: 54%;
  height: 30px;
  line-height: 30px;
  margin-right: 12px;
}
.jcyy-input-suffix>>> .el-input{
  flex: 1;
  height: 30px;
  line-height: 30px;
  margin-right: 12px;
}
.demo-input-suffix >>> .el-input .el-input__inner{
  height: 30px;
  line-height: 30px;
}

.demo-input-suffix >>> .el-input .el-input__inner:focus,.jcyy-input-suffix >>> .el-textarea .el-textarea__inner:focus {
  border-color: #27afa1;
}
.src-components-PatInfo-1sipu >>> .el-input__icon{
  line-height: 30px;
}
.cjyp-table-html{
  flex: 1;

}

/* 媒体查询 */
@media only screen and (max-width: 1366px) {
  .el-checkbox >>> .el-checkbox__label {
    font-size: 12px;
  }

  .el-input-box >>> .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  .el-input-box >>> .el-button {
    height: 30px;
  }
}
</style>
